import { render, staticRenderFns } from "./Fixationnav.vue?vue&type=template&id=765815d9&scoped=true&"
import script from "./Fixationnav.vue?vue&type=script&lang=js&"
export * from "./Fixationnav.vue?vue&type=script&lang=js&"
import style0 from "./Fixationnav.vue?vue&type=style&index=0&id=765815d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765815d9",
  null
  
)

export default component.exports